// src/components/MainPanel/NoteViewMain.js
import React, { forwardRef } from 'react';
import Modal from 'react-modal';
import RichTextEditor from './RichTextEditor';
import styles from './NoteViewMain.module.css';
import ImageManager from '../ImageManager/ImageManager';


Modal.setAppElement('#root');

const NoteViewMain = forwardRef(({ 
  note,                    // Instead of getting from context, receive as prop
  categories,
  onNoteChange,           // Handler passed from container
  onTitleChange,          // Handler passed from container
  onCategoryChange,  // Add this prop
  isImageUploadExpanded,  
  onToggleImageUpload, 
  onImagePaste,
  images,
  noteId,
  onImageUpload  // Add this prop if not already present
}, ref) => {


  const handleUploadSuccess = async () => {  // Remove uploadResult parameter
    console.log('NoteViewMain: handleUploadSuccess called');
    if (ref.current?.refreshImages) {
      console.log('Calling refreshImages');
      await ref.current.refreshImages();
    }
  };


  if (!note) {
    return <div className={styles.noteViewEmpty}>No note selected</div>;
  }

  return (
    <div className={styles.noteViewMain}>
      
      <div className={styles.noteHeader}>
        {/* <input   OLD INPUT
          type="text"
          value={note.title || ''}
          className={styles.noteTitleInput}
          placeholder="Note Title"
          onChange={(e) => onTitleChange(e.target.value)}
        /> */}
      </div>
      <ImageManager
        noteId={noteId}
        onUploadSuccess={handleUploadSuccess}
        isExpanded={isImageUploadExpanded}
        onToggleExpand={onToggleImageUpload}
      />

     
      <RichTextEditor
        initialValue={note.content || ''}
        onChange={onNoteChange}
        placeholder="Start writing your note..."
        categories={categories}
        selectedCategoryId={note?.primary_category_id}
        onCategoryChange={onCategoryChange}
      />
    </div>
  );
});

export default React.memo(NoteViewMain);